/* eslint-disable camelcase */

import { gql } from "@apollo/client";
import {
  TCommandResult,
  TEnumerableCommandResult,
  TListCommandResult
} from "../helpers/utils.graphql";

const EnumerableCommandResult = (
  entityEnumerableCommandResult: TEnumerableCommandResult
) => gql`
  fragment ENUMERABLE_COMMAND_RESULT on ${entityEnumerableCommandResult} {
    status,
    message,
    errorCode,
    notifications {
      propertyName,
      errorMessage
    }
  }
`;

const CommandResult = (entityCommandResultName: TCommandResult) => gql`
  fragment COMMAND_RESULT on ${entityCommandResultName} {
    status,
    message,
    errorCode,
    notifications {
      propertyName,
      errorMessage
    }
  }
`;

const ListCommandResult = (
  entityListCommandResultName: TListCommandResult
) => gql`
  fragment LIST_COMMAND_RESULT on ${entityListCommandResultName} {
    status,
    message,
    errorCode,
    notifications {
      propertyName,
      errorMessage
    },
    page
    perPage,
    pageCount,
    totalCount
  }
`;

export { CommandResult, ListCommandResult, EnumerableCommandResult };
